import { ReactNode } from "react";
import cn from "clsx";

export interface TabItem {
  id: string;
  label: ReactNode;
  /** Optionaler Zähler/Badge rechts vom Label. */
  badge?: ReactNode;
}

export interface TabsProps {
  items: TabItem[];
  value: string;
  onChange: (id: string) => void;
  className?: string;
}

/** Unterstrich-Tabs, tokenisiert (Spec §3). */
export function Tabs({ items, value, onChange, className }: TabsProps) {
  return (
    <div
      role="tablist"
      className={cn("flex items-center gap-1 border-b border-border", className)}
    >
      {items.map((it) => {
        const active = it.id === value;
        return (
          <button
            key={it.id}
            role="tab"
            aria-selected={active}
            onClick={() => onChange(it.id)}
            className={cn(
              "relative inline-flex items-center gap-1.5 px-3 py-2 text-sm font-medium -mb-px border-b-2 transition-colors",
              active
                ? "border-accent-500 text-text"
                : "border-transparent text-text-2 hover:text-text hover:border-border-strong"
            )}
          >
            {it.label}
            {it.badge != null && (
              <span
                className={cn(
                  "inline-flex items-center justify-center min-w-[1.25rem] px-1 rounded-full text-xs",
                  active ? "bg-accent-100 text-accent-700" : "bg-surface-3 text-text-2"
                )}
              >
                {it.badge}
              </span>
            )}
          </button>
        );
      })}
    </div>
  );
}

export default Tabs;
